import { BoxProps } from '../Box'
import { CenterChildren } from '../Center'

import { Spin, SpinSize } from './Spin'

export const PageLoader = (props: BoxProps) => (
  <CenterChildren {...props}>
    <Spin size={SpinSize.ExtraLarge} />
  </CenterChildren>
)
